import { ReactNode, useEffect } from 'react';
import { useLocation } from 'react-router-dom';

interface IProps {
    children: ReactNode;
}

export const ScrollToTop = ({ children }: IProps) => {
    const location = useLocation();

    useEffect(() => {
        window.scrollTo(0, 0);
    }, [location]);

    return <>{children}</>;
};
